import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-white border-t border-gray-200 mt-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* About */}
          <div>
            <h3 className="text-lg font-semibold text-gray-900 mb-3">RayShare</h3>
            <p className="text-sm text-gray-600">
              Secure peer-to-peer file sharing directly in your browser. 
              No accounts, no limits, complete privacy.
            </p>
          </div>

          {/* Features */}
          <div>
            <h3 className="text-lg font-semibold text-gray-900 mb-3">Features</h3>
            <ul className="space-y-2 text-sm text-gray-600">
              <li>✅ End-to-End Encryption</li>
              <li>✅ No File Size Limits</li>
              <li>✅ Direct P2P Transfer</li>
              <li>✅ No Account Required</li>
            </ul>
          </div>

          {/* Info */}
          <div>
            <h3 className="text-lg font-semibold text-gray-900 mb-3">Information</h3>
            <p className="text-sm text-gray-600 mb-2">
              Built with WebRTC technology
            </p>
            <p className="text-sm text-gray-600">
              © 2026 RayShare. All rights reserved.
            </p>
          </div>
        </div>

        <div className="mt-8 pt-6 border-t border-gray-200 text-center text-sm text-gray-500">
          Made with ❤️ by Rayyan Khan
        </div>
      </div>
    </footer>
  );
};

export default Footer;
